"use client"

/* eslint-disable react/button-has-type */
/* eslint-disable no-nested-ternary */
import clsx from "clsx"
import React, { useState } from "react"

import { IndividualBlogPostProps } from "@/app/insights/_types/insights"
import RichTextResponse from "@/helpers/renderRichText"

interface SectionCopy {
  title: string
  description?: IndividualBlogPostProps["contentRich"]
}

const FAQListItem: React.FC<{
  content: SectionCopy
  row: number
  sectionId: number
  mode?: "dark" | "light"
  theme?: {
    hoverBgColor: string
    textColor: string
    textHexColor: string
  }
  open?: boolean
}> = ({ content, row, sectionId, mode = "dark", theme, open = false }) => {
  const [toggleOpen, setToggleOpen] = useState(open)

  return (
    <li
      className="relative my-2 list-none faq-list-item"
      itemScope
      itemProp="mainEntity"
      itemType="https://schema.org/Question"
    >
      <button
        className={clsx(
          "group p-4 lg:p-6 xl:p-8 flex justify-between items-center flex-grow-0 flex-shrink-0 hover:rounded-t-lg w-full rounded-lg",
          toggleOpen && "rounded-b-none",
          toggleOpen && mode === "light"
            ? theme && theme.hoverBgColor
              ? theme.hoverBgColor
              : "bg-gray-10"
            : "bg-none",
          toggleOpen && mode === "dark"
            ? theme && theme.hoverBgColor
              ? theme.hoverBgColor
              : "bg-gray-85"
            : "bg-none",
          mode === "dark"
            ? theme && theme.hoverBgColor
              ? `hover:${theme.hoverBgColor}`
              : "hover:bg-gray-85"
            : "hover:bg-gray-10",
        )}
        onClick={() => setToggleOpen(!toggleOpen)}
      >
        <h3
          className={clsx(
            mode === "dark"
              ? theme && theme.textColor
                ? theme.textColor
                : "text-gray-2.5"
              : "text-gray-90",
            "flex-grow-0 flex-shrink-1 ease-in-out md:mr-0 mr-4 xl:body1 md:body2 body3",
          )}
          itemProp="name"
        >
          {content.title}
        </h3>
        <div
          className={clsx(
            "relative flex-grow-0 flex-shrink-0",
            toggleOpen && "rotate-45",
          )}
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6 "
            preserveAspectRatio="none"
          >
            <rect
              width="15"
              height="2"
              transform="matrix(0.000136303 1 -1 0.000137483 13.0011 4.50195)"
              fill={
                mode === "dark"
                  ? theme && theme.textHexColor
                    ? theme.textHexColor
                    : "white"
                  : "black"
              }
            />
            <rect
              width="15"
              height="2"
              transform="matrix(-1 0.000137694 0.000136092 1 19.502 11.001)"
              fill={
                mode === "dark"
                  ? theme && theme.textHexColor
                    ? theme.textHexColor
                    : "white"
                  : "black"
              }
            />
          </svg>
        </div>
      </button>
      <div
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
      >
        <span
          id={`${sectionId}_row${row}`}
          className={clsx(
            "rounded-b-lg p-4 lg:pb-6 lg:pt-2 lg:px-6 xl:pb-8 xl:px-8 bg-opacity-50 hover:bg-opacity-100 body3",
            mode === "dark" ? "faq-list-item" : "faq-list-item-light",
            toggleOpen ? "block" : "hidden",
            mode === "dark"
              ? theme && theme.hoverBgColor
                ? theme.hoverBgColor
                : "bg-gray-85"
              : "bg-gray-10",
            theme?.textColor,
          )}
          itemProp="text"
        >
          <RichTextResponse
            legal={false}
            richTextResponse={content.description}
          />
        </span>
      </div>
    </li>
  )
}

export default FAQListItem
